import React from "react";
import http from '../modules/api';

import DatePicker from "react-datepicker";
import { is, ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import Button from '../modules/common/Button';

import SaveDialogV2 from "../modules/dialogs/SaveDialogV2";
import WarningDialog from "../modules/dialogs/WarningDialog";
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";

import { PreviewRoot } from "./component/PreviewRoot";         
import PreviewTrigger from "./component/PreviewTrigger";
import { event } from "react-ga";

// 상품 자동설정 전용 옵션
const STATUS_OPTIONS = [
  { text: "전체 상태", value: "" },
  { text: "활성",     value: "Y" },
  { text: "중지",     value: "N" },
];

const TYPE_OPTIONS = [
  { text: "전체 유형", value: "" },
  { text: "싱글 피드",    value: "SINGLE" },
  { text: "슬라이드 피드",     value: "SLIDE" },
];

export default class InstagramAiImageAutomationList_v4 extends React.Component {
  static defaultProps = { pageSizes: [{value: 20, text: "20개"}, {value: 50, text: "50개"}, {value: 100, text: "100개"}] };

  constructor(props) {
    super(props);
    this.state = {
      posts: [],
      status: "",
      type: "",
      textMode: "",
      hashtagMode: "",
      publishType: "",
      startDate: null,
      endDate: null,
      page: 1,
      pageSize: 20,
      sortKey: "ias.reg_date",
      sortDir: "desc",
      selected: new Set(),
      total: 0,
      tutorialListLoaded: false,
      threadsAccountMap: {},

      deletingSettingSeq: null,
      duplicatingSettingSeq: null,

      save_dialog_show_state: false,
      save_dialog_content: "",
      save_dialog_button_list: [],

      warning_dialog_show_state: false,
      warning_dialog_content: "",
      warning_dialog_button_list: [],

      title_content_dialog_show_state: false,
      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [],
    };
  }

  componentDidMount() {
    this.loadThreadsAccountMap();
    this.fetchPostsFromApi();
  }


  loadThreadsAccountMap = async () => {
    try {
      const res = await http.get("/rest/shop/threds/profile/list");
      const list = Array.isArray(res?.data?.list) ? res.data.list : [];
      const threadsAccountMap = {};
      list.forEach((row) => {
        const seq = String(row?.threads_access_token_seq ?? "");
        if (!seq) return;
        const username = row?.username || row?.threads_user_id || `계정 #${seq}`;
        threadsAccountMap[seq] = username.startsWith("@") ? username : `@${username}`;
      });
      this.setState({ threadsAccountMap });
    } catch (error) {
      console.error("Threads 계정 목록 조회 실패", error);
      this.setState({ threadsAccountMap: {} });
    }
  };

  getThreadsAccountLabel = (seq) => {
    if (seq === null || seq === undefined || String(seq).trim() === "") return "-";
    const key = String(seq);
    return this.state.threadsAccountMap?.[key] || `계정 #${key}`;
  };

  /**
   * API 호출: 상품 자동설정 목록
   * GET /shop/instagram/product-auto-settings/list
   * params: feed_type, product_select_logic?, text_mode?, hashtag_mode?, is_enabled, sort_by, sort_dir, start, row_cnt
   */
  fetchPostsFromApi = async () => {
    const tutorialRequestSeq = (this.tutorialListRequestSeq || 0) + 1;
    this.tutorialListRequestSeq = tutorialRequestSeq;
    this.setState({ tutorialListLoaded: false });

    const {
      status,
      type,
      textMode,
      hashtagMode,
      publishType,
      startDate,
      endDate,
      page,
      pageSize,
      sortKey,
      sortDir
    } = this.state;

    const formatDate = (date) => {
      if (!date) return null;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    try {
      const resp = await http.get("/rest/shop/instagram/auto/aiImage/setting/list", {
        params: {
          feed_type: type || "",
          text_mode: textMode || "",
          hashtag_mode: hashtagMode || "",
          publish_type: publishType || "",
          is_enabled: status || "",
          sort_by: sortKey || "ias.reg_date",
          sort_dir: (sortDir || "desc").toUpperCase(),
          start: (page - 1) * pageSize,
          row_cnt: pageSize,
          start_date: startDate ? formatDate(startDate) : null,
          end_date: endDate ? formatDate(endDate) : null,
        },
      });

      const { total, list } = resp.data;

      const posts = (list || []).map((m) => {
        const statusLabel = m.is_enabled === "Y" ? "활성" : "중지";

        return {
          id: String(m.instagram_ai_image_auto_setting_seq),
          setting_name: m.setting_name || "",
          type: m.feed_type || "-",
          slide_count: m.slide_count || "",
          image_ratio: m.image_ratio_for_list || "",
          is_enabled: m.is_enabled || "N",
          status: statusLabel,

          username: m.username || "",
          facebook_username: m.facebook_username || "",
          instagram_access_token_seq: m.instagram_access_token_seq ?? null,
          threads_access_token_seq: m.threads_access_token_seq ?? null,
          instagram_publish_yn: String(m.instagram_publish_yn ?? "Y").toUpperCase(),
          threads_publish_yn: String(m.threads_publish_yn ?? "N").toUpperCase(),

          publish_cycle: m.publish_cycle || "",
          scheduled_time: m.scheduled_time || "",
          week_days: m.week_days || "",

          reg_date: m.reg_date || "",
          reg_date_format: m.reg_date_format || "",

          text_mode: m.text_mode || "",
          copywriter_preset_seq: m.copywriter_preset_seq || null,
          copywriter_preset_title: m.copywriter_preset_title || "",
          hashtag_mode: m.hashtag_mode || "",
          publish_type: m.publish_type || "",

          history_title: m.history_title || "",
          workflow_status: m.workflow_status || "",

          caption_count: Number(m.caption_count || 0),
          hashtag_count: Number(m.hashtag_count || 0),
          learned_feed_count: Number(m.learned_feed_count || 0),
          step_count: Number(m.step_count || 0),

          final_step_no: Number(m.final_step_no || 0),
          final_generated_image_url: m.final_generated_image_url || "",
          final_generated_thumbnail_url: m.final_generated_thumbnail_url || "",

          start_date: m.start_date || "",
          start_date_format: m.start_date_format || "",
          last_success_at: m.last_success_at || "",
          last_success_at_format: m.last_success_at_format || "",
        };
      });

      this.setState({
        posts,
        total: Number(total || 0),
      });
    } catch (err) {
      console.error("AI 이미지 자동설정 목록 조회 실패", err);
    } finally {
      if (this.tutorialListRequestSeq === tutorialRequestSeq) {
        this.setState({ tutorialListLoaded: true });
      }
    }
  };

  // 유틸
  fmtNumber(n) { return (n === null || n === undefined) ? "-" : Number(n).toLocaleString(); }

  // 이벤트
  changeSort = (key) => {
    this.setState((prev) =>
      prev.sortKey === key
        ? { sortDir: prev.sortDir === "asc" ? "desc" : "asc" }
        : { sortKey: key, sortDir: "desc" }
    , this.fetchPostsFromApi);
  };
  handleInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value, page: 1 });
  };
  setQuickRange = (type) => {
    const today = new Date();
    if (type === "today") {
      this.setState({ startDate: today, endDate: today, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "week") {
      const day = today.getDay();
      const diff = day === 0 ? 6 : day - 1;
      const monday = new Date(today); monday.setDate(today.getDate() - diff);
      const sunday = new Date(monday); sunday.setDate(monday.getDate() + 6);
      this.setState({ startDate: monday, endDate: sunday, page: 1 }, this.fetchPostsFromApi);
    } else if (type === "month") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      this.setState({ startDate: first, endDate: last, page: 1 }, this.fetchPostsFromApi);
    } else {
      this.setState({ startDate: null, endDate: null, page: 1 }, this.fetchPostsFromApi);
    }
    this.setState({ dateType: type });
  };

  goPage = (p) => this.setState({ page: p }, this.fetchPostsFromApi);
  changePageSize = (e) => this.setState({ pageSize: Number(e.target.value), page: 1 }, this.fetchPostsFromApi);

  // 기존 TextInput과 SelectBoxV2를 그대로 사용하기 위해 래핑
  handleSelectBox = (name) => (text, value) => {
    this.handleInput({ target: { name, value } });
  };

  renderSortHead(label, key, align = "left", width = "auto") {
    const { sortKey, sortDir } = this.state;
    const active = sortKey === key;
    const arrow = active ? (sortDir === "asc" ? "▲" : "▼") : "";
    return (
      <th onClick={() => this.changeSort(key)} style={{ width, cursor: "pointer", textAlign: align }} title="정렬">
        {label} {/* arrow */}
      </th>
    );
  }

  // 활성/중지 토글 클릭
  // onClickToggleEnabled = async (e, settingSeq, stateKey, nextYN) => {
  //   e.stopPropagation();

  //   const prevYN = this.state[stateKey] ?? "Y"; // 기본 Y로 간주(초기엔 서버값 사용)
  //   // 낙관적 UI 업데이트
  //   this.setState({ [stateKey]: nextYN });

  //   try {
  //     // 예시1) POST 본문
  //     await http.post("/shop/instagram/product-auto-settings/enabled", {
  //       instagram_product_auto_setting_seq: settingSeq,
  //       is_enabled: nextYN,
  //     });
  //   } catch (err) {
  //     console.error("활성/중지 변경 실패", err);
  //     // 실패 → 롤백
  //     this.setState({ [stateKey]: prevYN });
  //     alert("변경에 실패했습니다. 잠시 후 다시 시도해주세요.");
  //   }
  // };

  renderScheduleCell = (m /* = row.__raw */) => {
    // 1) 주기 라벨 (네 패턴의 '일별' 자리에 매핑)
    const cycleLabel =
      m.publish_cycle === "DAILY" ? "매일" :
      m.publish_cycle === "WEEKLY" ? "매주" :
      m.publish_cycle === "BIDAY" ? "격일" :
      m.publish_cycle === "THREETIMES" ? "주 3회" :
      m.publish_cycle === "CUSTOM" ? "사용자 지정" :
      // publish_cycle만 있는 케이스 → 일별로 간주
      (m.publish_cycle != null ? "일별" : (m.publish_cycle || "일별"));


    const DAY_KO = ['일', '월', '화', '수', '목', '금', '토'];
    const toKoWeekdays = (m.week_days || '')
        .split(',')                   // ['0','1','2','3','']
        .map(s => s.trim())
        .filter(s => s !== '')        // 빈 값 제거 (트레일링 콤마 대응)
        .map(n => DAY_KO[Number(n)])  // 숫자 → 한글 요일
        .filter(Boolean)              // 유효하지 않은 인덱스 제거
        .join(', ');

    // 2) 월, 수,금... 마다
    // - publish_cycle 이 있으면 그대로 사용
    // - 없고 DAILY면 1일 마다로 표기하고 싶으면 아래 주석 해제
    const dayWeekly = (m.publish_cycle != null)
      ? `${toKoWeekdays}${m.publish_cycle=="WEEKLY"? "요일": ""} 마다`
      : null;

   // 3) 시간 표기: event_time 우선, 없으면 scheduled_time(HH:mm:ss) → HH시에
    const hourFromScheduled = m.scheduled_time
      ? m.scheduled_time.slice(0, 2)  // 앞 두 자리만 추출 (ex: "10:00:00" → "10")
      : null;

    const eventHour =
      m.event_time != null && m.event_time !== ""
        ? `${String(m.event_time).padStart(2, "0")}시에`
        : hourFromScheduled
        ? `${hourFromScheduled}시에`
        : null;

    // 4) 예약일
    const nextRun = m.next_auto_run_date ? `예약일 ${m.next_auto_run_date}` : null;

    return (
      <div style={{ display: "flex", flexDirection: "row", gap: "6px", flexWrap: "wrap", justifyContent: "center" }}>
        <div>{cycleLabel}</div>
        {m.publish_cycle === "WEEKLY" && dayWeekly ? <div><span style={{wordBreak: "keep-all"}}>{dayWeekly}</span></div> : null}
        {eventHour ? <div>{eventHour}</div> : null}
        {nextRun ? <div>{nextRun}</div> : null}
      </div>
    );
  };

  // 활성/중지 토글 API 경로
  onClickToggleEnabled = async (e, settingSeq, stateKey, nextYN) => {
    e.stopPropagation();

    const prevYN = this.state[stateKey] ?? "Y";
    this.setState({ [stateKey]: nextYN });

    http.put(
      "/rest/shop/instagram/auto/aiImage/setting/isEnabled/update",
      null,
      {
        params: {
          instagram_ai_image_auto_setting_seq: settingSeq,
          is_enabled: nextYN,
        }
      }
    ).then((response) => {
      const updatedCount = Number(response?.data?.cnt || 0);
      if (updatedCount < 1) {
        this.setState({ [stateKey]: prevYN });
        const message = nextYN === "Y"
          ? "자동화를 활성화할 수 없습니다. 선택한 발행 채널의 계정 연결 상태를 확인해주세요."
          : "변경에 실패했습니다. 잠시 후 다시 시도해주세요.";
        alert(message);
      }
    }).catch((err) => {
      console.error("활성/중지 변경 실패", err);
      this.setState({ [stateKey]: prevYN });
      alert("변경에 실패했습니다. 잠시 후 다시 시도해주세요.");
    });
  };


  closeWarningDialog = () => {
    this.setState({ warning_dialog_show_state: false });
  };

  showWarningDialog = (content) => {
    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: content,
      warning_dialog_button_list: [{
        title: "확인",
        type: "1",
        event_method: this.closeWarningDialog,
      }],
    });
  };

  closeDeleteConfirmDialog = () => {
    this.setState({
      title_content_dialog_show_state: false,
      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [],
    });
  };

  openDeleteConfirmDialog = (e, row) => {
    e.stopPropagation();

    this.setState({
      title_content_dialog_show_state: true,
      title_content_dialog_title: "AI 이미지 자동화 설정을 삭제하시겠습니까?",
      title_content_dialog_content: "삭제한 AI 이미지 자동화 설정은 복구할 수 없습니다.",
      title_content_dialog_button_list: [
        {
          title: "삭제",
          type: "1",
          event_method: () => {
            this.closeDeleteConfirmDialog();
            this.deleteAutomationSetting(row);
          },
        },
        {
          title: "취소",
          type: "0",
          event_method: this.closeDeleteConfirmDialog,
        },
      ],
    });
  };

  deleteAutomationSetting = async (row) => {
    if (!row?.id || this.state.deletingSettingSeq) return;

    this.setState({
      deletingSettingSeq: row.id,
      save_dialog_show_state: true,
      save_dialog_content: "삭제 중입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.delete(
        `/rest/shop/instagram/auto/aiImage/setting/${encodeURIComponent(row.id)}`
      );
      const result = response?.data || {};

      if (result.status !== "success") {
        throw new Error(result.message || "삭제에 실패했습니다.");
      }

      const nextPage = this.state.posts.length === 1 && this.state.page > 1
        ? this.state.page - 1
        : this.state.page;

      await new Promise((resolve) => this.setState({ page: nextPage }, resolve));
      await this.fetchPostsFromApi();

      this.setState({
        deletingSettingSeq: null,
        save_dialog_show_state: true,
        save_dialog_content: "삭제 완료되었습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false }),
        }],
      });
    } catch (error) {
      console.error("AI 이미지 자동화 설정 삭제 실패", error);
      this.setState({
        deletingSettingSeq: null,
        save_dialog_show_state: false,
        save_dialog_content: "",
        save_dialog_button_list: [],
      }, () => {
        this.showWarningDialog(error?.message || "삭제 중 오류가 발생했습니다.");
      });
    }
  };
  duplicateAutomationSetting = async (e, row) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (!row?.id || this.state.duplicatingSettingSeq || this.state.deletingSettingSeq) return;

    this.setState({
      duplicatingSettingSeq: row.id,
      save_dialog_show_state: true,
      save_dialog_content: "복제 중입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.post(
        `/rest/shop/instagram/auto/aiImage/setting/${encodeURIComponent(row.id)}/duplicate`
      );
      const result = response?.data || {};
      if (result.status !== "success" && result.result !== "success") {
        throw new Error(result.message || "복제에 실패했습니다.");
      }

      await new Promise((resolve) => this.setState({ page: 1 }, resolve));
      await this.fetchPostsFromApi();
      this.setState({
        duplicatingSettingSeq: null,
        save_dialog_show_state: true,
        save_dialog_content: result.message || "복제 완료되었습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false }),
        }],
      });
    } catch (error) {
      console.error("AI 이미지 자동화 설정 복제 실패", error);
      const message = error?.response?.data?.message || error?.message || "복제 중 오류가 발생했습니다.";
      this.setState({
        duplicatingSettingSeq: null,
        save_dialog_show_state: false,
        save_dialog_content: "",
        save_dialog_button_list: [],
      }, () => {
        this.showWarningDialog(message);
      });
    }
  };



  render() {
    const { status, type, startDate, endDate, page, pageSize, dateType, tutorialListLoaded } = this.state;
    const rows = this.state.posts;
    const total = this.state.total ?? rows.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));

    const renderPageButtons = () => {
      const maxButtons = 5;
      const half = Math.floor(maxButtons / 2);
      let start = Math.max(1, page - half);
      let end = Math.min(totalPages, start + maxButtons - 1);

      if (end - start < maxButtons - 1) {
        start = Math.max(1, end - maxButtons + 1);
      }

      return Array.from({ length: end - start + 1 }).map((_, i) => {
        const p = start + i;
        return (
          <button
            key={p}
            type="button"
            className={p === page ? "active" : ""}
            onClick={() => this.goPage(p)}
          >
            {p}
          </button>
        );
      });
    };

    return (
      <>
        <style>
          {`
            .instagram-ai-image-automation-list {
              --primary-mint: #00e2e6;
              --primary-dark: #00bfc2;
              --navy-dark: #0A1A2F;
              --bg-body: #f4f7f9;
              --bg-canvas: #ffffff;
              --text-primary: #111827;
              --text-secondary: #4b5563;
              --text-muted: #9ca3af;
              --border-color: #e5e7eb;
              --border-light: #f3f4f6;
              background-color: var(--bg-body);
              color: var(--text-primary);
              min-height: 100%;
              width: 100%;
              letter-spacing: -0.3px;
              overflow-x: hidden;
              font-family: 'Noto Sans KR', sans-serif;
            }

            #page-wrapper {
              padding: 72px 0 0 220px;
              max-width: 100%;
            }

            .instagram-ai-image-automation-list .badge {
              display: inline-block;
              padding: 4px 8px;
              border-radius: 4px;
              font-size: 11px;
              font-weight: 500;
            }

            .instagram-ai-image-automation-list .badge-auto { background: #e3f2fd; color: #1976d2; }
            .instagram-ai-image-automation-list .badge-manual { background: #f3e5f5; color: #7b1fa2; }
            .instagram-ai-image-automation-list .badge-published { background: #e8f5e9; color: #2e7d32; }
            .instagram-ai-image-automation-list .badge-scheduled { background: #e3f2fd; color: #1976d2; }
            .instagram-ai-image-automation-list .badge-draft { background: #fff3e0; color: #f57c00; }
            .instagram-ai-image-automation-list .badge-failed { background: #ffebee; color: #ed4956; }
            .instagram-ai-image-automation-list .badge-neutral { background: #f1f3f5; color: var(--text-primary); }

            .instagram-ai-image-automation-list .copywriter-setting-wrap {
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 5px;
            }

            .instagram-ai-image-automation-list .copywriter-preset-title {
              max-width: 100%;
              font-size: 11px;
              line-height: 1.35;
              font-weight: 400;
              color: var(--text-secondary);
              word-break: keep-all;
              overflow-wrap: anywhere;
            }


            .instagram-ai-image-automation-list .automation-status-toggle {
              width: 124px;
              height: 40px;
              margin: 0 auto;
              cursor: pointer;
              user-select: none;
            }

            .instagram-ai-image-automation-list .automation-status-toggle .automation-status-track {
              position: relative;
              width: 124px;
              height: 40px;
              overflow: hidden;
              border-radius: 6px;
              background: #f2f3f5 !important;
              box-shadow: inset 0px 2px 0px #E7E9ED !important;
              color: #b0b6bf;
              margin: 0 !important;
              padding: 0 !important;
              font-size: 10px;
              font-weight: 600;
            }

            .instagram-ai-image-automation-list .automation-status-toggle .automation-status-back-label {
              position: absolute;
              top: 0;
              width: 32px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              z-index: 0;
            }

            .instagram-ai-image-automation-list .automation-status-toggle .automation-status-back-label.left {
              left: 0;
            }

            .instagram-ai-image-automation-list .automation-status-toggle .automation-status-back-label.right {
              right: 0;
            }

            .instagram-ai-image-automation-list .automation-status-toggle .automation-status-front {
              position: absolute;
              top: 0;
              width: 92px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              border-radius: 6px;
              z-index: 1;
              font-size: 12px;
              font-weight: 500;
              transition: left 0.15s ease, right 0.15s ease;
              white-space: nowrap;
              margin: 0 !important;
              padding: 0 !important;
            }

            .instagram-ai-image-automation-list .automation-status-toggle .automation-status-front.running {
              left: 0 !important;
              right: auto !important;
              background: #00e2e6 !important;
              color: #363636 !important;
            }

            .instagram-ai-image-automation-list .automation-status-toggle .automation-status-front.stopped {
              left: auto !important;
              right: 0 !important;
              background: #9ca3af !important;
              color: #ffffff !important;
            }

            .instagram-ai-image-automation-list *,
            .instagram-ai-image-automation-list *::before,
            .instagram-ai-image-automation-list *::after {
              box-sizing: border-box;
            }

            .instagram-ai-image-automation-list button,
            .instagram-ai-image-automation-list input,
            .instagram-ai-image-automation-list select {
              font-family: inherit;
            }

            .instagram-ai-image-automation-list .fa {
              font-family: "Font Awesome 6 Free" !important;
              font-weight: 900;
            }

            .instagram-ai-image-automation-list .main-content {
              display: flex;
              flex-direction: column;
              min-width: 0;
              width: 100%;
            }

            .instagram-ai-image-automation-list .top-header {
              height: 50px;
              background-color: var(--bg-canvas);
              border-bottom: 1px solid var(--border-color);
              display: flex;
              align-items: center;
              padding: 0 24px;
              font-size: 13px;
              font-weight: 600;
              color: var(--text-primary);
              flex-shrink: 0;
            }

            .instagram-ai-image-automation-list .top-header span {
              color: var(--text-muted);
              font-weight: 400;
              margin-right: 8px;
            }

            .instagram-ai-image-automation-list .content-inner {
              padding: 32px 40px;
              max-width: 1600px;
              width: 100%;
              margin: 0 auto;
              display: flex;
              flex-direction: column;
              gap: 32px;
              flex: 1;
              min-height: calc(100vh - 72px);
            }

            .instagram-ai-image-automation-list .center-hero {
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              gap: 12px;
              margin-bottom: 8px;
            }

            .instagram-ai-image-automation-list .center-hero h2 {
              font-size: 24px;
              font-weight: 800;
              color: var(--navy-dark);
              margin: 0;
            }

            .instagram-ai-image-automation-list .center-hero p {
              font-size: 14px;
              color: var(--text-secondary);
              margin: 0 0 12px 0;
              max-width: 800px;
              line-height: 1.5;
              word-break: keep-all;
            }

            .instagram-ai-image-automation-list .hero-button-wrap {
              display: inline-flex;
            }

            .instagram-product-automation-list .common_button.hover_mint,
            .instagram-ai-image-automation-list .common_button.hover_mint {
              border-radius: 8px !important;
              font-weight: 700 !important;
              box-shadow: 0 4px 12px rgba(0, 226, 230, 0.2);
              transition: all 0.2s !important;

              display: flex;
              justify-content: center;
              align-items: center;
              gap: 8px;
            }
            
            .instagram-product-automation-list .common_button.hover_mint:hover,
            .instagram-ai-image-automation-list .common_button.hover_mint:hover {
              background:#00D3E0 !important;
              transform: translateY(-2px) !important;
            }

            .instagram-product-automation-list .common_button.hover_mint::after,
            .instagram-ai-image-automation-list .common_button.hover_mint::after {
              width: 0px !important;
              height: 0px !important;
            }

            .instagram-ai-image-automation-list .workflow-container {
              background: var(--bg-canvas);
              border: 1px solid var(--border-color);
              border-radius: 12px;
              padding: 32px;
              margin-bottom: 8px;
              display: flex;
              align-items: center;
              justify-content: space-between;
              box-shadow: 0 2px 12px rgba(10, 26, 47, 0.03);
            }

            .instagram-ai-image-automation-list .workflow-step {
              flex: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              text-align: center;
              padding: 0 24px;
            }

            .instagram-ai-image-automation-list .workflow-icon {
              width: 48px;
              height: 48px;
              border-radius: 50%;
              background: rgba(0, 226, 230, 0.08);
              color: var(--primary-dark);
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 20px;
              margin-bottom: 16px;
            }

            .instagram-ai-image-automation-list .workflow-step h4 {
              font-size: 15px;
              font-weight: 700;
              color: var(--navy-dark);
              margin: 0 0 12px 0;
              display: flex;
              align-items: center;
              gap: 8px;
            }

            .instagram-ai-image-automation-list .workflow-step h4 .step-num {
              font-size: 11px;
              font-weight: 800;
              color: #00999c;
              background: rgba(0, 226, 230, 0.15);
              width: 20px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            }

            .instagram-ai-image-automation-list .workflow-step p {
              font-size: 13px;
              color: var(--text-secondary);
              line-height: 1.6;
              word-break: keep-all;
              margin: 0;
            }

            .instagram-ai-image-automation-list .workflow-divider {
              flex-shrink: 0;
              width: 30px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #e2e8f0;
              font-size: 22px;
              padding-bottom: 30px;
            }

            .instagram-ai-image-automation-list .list-section-wrapper {
              background: var(--bg-canvas);
              border: 1px solid var(--border-color);
              border-radius: 12px;
              box-shadow: 0 2px 8px rgba(10, 26, 47, 0.02);
              overflow: visible;
            }

            .instagram-ai-image-automation-list .filter-header {
              padding: 20px;
              border-bottom: 1px solid var(--border-color);
              display: flex;
              flex-direction: column;
              gap: 16px;
              position: relative;
              z-index: 5;
            }

            .instagram-ai-image-automation-list .filter-controls-row {
              display: flex;
              gap: 12px;
              flex-wrap: wrap;
              align-items: center;
            }

            .instagram-ai-image-automation-list .filter-select-wrap {
              flex: 1;
              min-width: 150px;
            }

            .instagram-ai-image-automation-list .filter-select-wrap .form-control {
              border: 1px solid var(--border-color) !important;
              border-radius: 6px !important;
              font-size: 13px !important;
              color: var(--text-primary) !important;
              min-height: 40px !important;
            }

            .instagram-ai-image-automation-list .date-range-group {
              display: flex;
              align-items: center;
              gap: 8px;
              flex: 2;
              min-width: 300px;
            }

            .instagram-ai-image-automation-list .select_area {
              border-color: var(--border-color) !important;
              border-radius: 6px !important;
            }

            .instagram-ai-image-automation-list .react-datepicker-wrapper {
              margin-bottom: 0 !important;
            }

            .instagram-ai-image-automation-list .date-range-group > div {
              flex: 1;
            }

            .instagram-ai-image-automation-list .react-datepicker-wrapper {
              width: 100%;
            }

            .instagram-ai-image-automation-list .date-input {
              padding: 10px 14px;
              border: 1px solid var(--border-color);
              border-radius: 6px;
              font-size: 13px;
              width: 100%;
              height: 40px;
              outline: none;
              text-align: center;
              color: var(--text-primary);
              background: #fff;
            }

            .instagram-ai-image-automation-list .btn-apply {
              background: #64748b;
              color: #fff;
              border: none;
              padding: 10px 24px;
              border-radius: 6px;
              font-size: 13px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s;
              white-space: nowrap;
              height: 40px;
            }

            .instagram-ai-image-automation-list .btn-apply:hover {
              background: var(--navy-dark);
            }

            .instagram-ai-image-automation-list .filter-chips-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              gap: 12px;
            }

            .instagram-ai-image-automation-list .chip-group {
              display: flex;
              gap: 6px;
              flex-wrap: wrap;
            }

            .instagram-ai-image-automation-list .chip-btn {
              padding: 6px 14px;
              border: 1px solid var(--border-color);
              background: var(--bg-canvas);
              border-radius: 20px;
              font-size: 12px;
              font-weight: 600;
              cursor: pointer;
              color: var(--text-secondary);
              transition: all 0.2s;
            }

            .instagram-ai-image-automation-list .chip-btn:hover:not(.active) {
              background: var(--border-light);
            }

            .instagram-ai-image-automation-list .chip-btn.active {
              background: #e2e8f0;
              color: #1e293b;
              border-color: #cbd5e1;
              font-weight: 700;
            }

            .instagram-ai-image-automation-list .total-count {
              font-size: 13px;
              color: var(--text-secondary);
            }

            .instagram-ai-image-automation-list .total-count span {
              font-weight: 700;
              color: var(--navy-dark);
            }

            .instagram-ai-image-automation-list .table-responsive {
              width: 100%;
              overflow-x: auto;
            }

            .instagram-ai-image-automation-list .robo-table {
              width: calc(100% + 180px);
              border-collapse: collapse;
              text-align: center;
              min-width: 1620px;
            }

            .instagram-ai-image-automation-list .robo-table th {
              background: #f8fafc;
              padding: 16px 12px;
              font-size: 13px;
              font-weight: 700;
              color: var(--navy-dark);
              border-bottom: 1px solid var(--border-color);
              white-space: nowrap;
            }

            .instagram-ai-image-automation-list .robo-table td {
              padding: 16px 12px;
              font-size: 13px;
              color: var(--text-secondary);
              border-bottom: 1px solid var(--border-light);
              vertical-align: middle;
            }

            .instagram-ai-image-automation-list .robo-table tr {
              cursor: pointer;
            }

            .instagram-ai-image-automation-list .robo-table tr:hover {
              background: #f8fafc;
            }

            .instagram-ai-image-automation-list .automation-action-group {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
            }

            .instagram-ai-image-automation-list .automation-duplicate-btn,
            .instagram-ai-image-automation-list .automation-delete-btn {
                align-items: center;
                background: #fff;
                border: 1px solid #333;
                border-radius: 6px;
                color: #333;
                cursor: pointer;
                display: inline-flex;
                font-size: 12px;
                font-weight: 700;
                gap: 5px;
                justify-content: center;
                min-width: 58px;
                padding: 7px;
                transition: all 0.2s ease;
              }

            .instagram-ai-image-automation-list .automation-duplicate-btn:hover:not(:disabled),
            .instagram-ai-image-automation-list .automation-delete-btn:hover:not(:disabled) {
                border-color: var(--primary-mint) !important;
                background: #f0fdfe !important;
              }

            .instagram-ai-image-automation-list .automation-duplicate-btn:disabled,
            .instagram-ai-image-automation-list .automation-delete-btn:disabled {
                opacity: 0.5;
                cursor: not-allowed;
              }

            .instagram-ai-image-automation-list .robo-table .text-left {
              text-align: left;
            }

            .instagram-ai-image-automation-list .cell-title {
              font-weight: 600;
              color: var(--text-primary);
              font-size: 14px;
              word-break: keep-all;
            }

            .instagram-ai-image-automation-list .cell-title span {
              font-size: 12px;
              color: var(--text-secondary);
              font-weight: 500;
              display: block;
              margin-top: 4px;
            }

            .instagram-ai-image-automation-list .cell-account {
              line-height: 1.4;
              color: var(--text-primary);
              word-break: keep-all;
            }

            .instagram-ai-image-automation-list .robo-table th:nth-child(3),
            .instagram-ai-image-automation-list .robo-table td:nth-child(3) {
              min-width: 180px;
            }

            .instagram-ai-image-automation-list .cell-account span {
              color: var(--text-muted);
              display: block;
              font-size: 12px;
            }
            .instagram-ai-image-automation-list .channel-account-list { display: flex; flex-direction: column; gap: 5px; }
            .instagram-ai-image-automation-list .channel-account-row { display: flex; align-items: center; gap: 6px; line-height: 1.3; }
            .instagram-ai-image-automation-list .channel-account-label { min-width: 58px; font-size: 10px; font-weight: 800; color: var(--text-muted); }
            .instagram-ai-image-automation-list .channel-account-value { font-size: 12px; color: var(--text-primary); word-break: break-all; }


            .instagram-ai-image-automation-list .cell-link {
              color: var(--primary-dark);
              font-weight: 500;
              text-decoration: none;
              line-height: 1.4;
              display: inline-block;
              word-break: keep-all;
            }

            .instagram-ai-image-automation-list .cell-link:hover {
              /* text-decoration: underline; */
            }

            .instagram-ai-image-automation-list .schedule-cell {
              line-height: 1.5;
              color: var(--text-secondary);
              white-space: nowrap;
            }

            .instagram-ai-image-automation-list .empty-cell {
              text-align: center;
              padding: 40px !important;
              color: var(--text-muted) !important;
              cursor: default;
            }

            .instagram-ai-image-automation-list .pagination-container {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 16px 20px;
              flex-wrap: wrap;
              gap: 16px;
              position: relative;
              z-index: 1;
            }

            .instagram-ai-image-automation-list .page-numbers {
              display: flex;
              gap: 4px;
              margin: 0 auto;
            }

            .instagram-ai-image-automation-list .page-numbers button {
              width: 32px;
              height: 32px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              border: 1px solid var(--border-color);
              background: var(--bg-canvas);
              color: var(--text-secondary);
              border-radius: 4px;
              font-size: 13px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.2s;
            }

            .instagram-ai-image-automation-list .page-numbers button:hover:not(:disabled) {
              background: var(--border-light);
            }

            .instagram-ai-image-automation-list .page-numbers button.active {
              background: #e2e8f0;
              color: #1e293b;
              border-color: #cbd5e1;
              font-weight: 700;
            }

            .instagram-ai-image-automation-list .page-numbers button:disabled {
              cursor: default;
              opacity: 0.45;
            }

            .instagram-ai-image-automation-list .page-size-selector {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 13px;
              color: var(--text-secondary);
              min-width: 190px;
              justify-content: flex-end;
            }

            .instagram-ai-image-automation-list .page-size-selector .form-control {
              border: 1px solid var(--border-color) !important;
              border-radius: 4px !important;
              font-size: 13px !important;
            }

            @media screen and (max-width: 1024px) {
              .instagram-ai-image-automation-list .top-header {
                display: none;
              }

              .instagram-ai-image-automation-list .content-inner {
                padding: 24px 16px;
                gap: 24px;
              }
            }

            @media screen and (max-width: 768px) {
              .instagram-ai-image-automation-list .center-hero {
                gap: 14px;
                margin-bottom: 8px;
              }

              .instagram-ai-image-automation-list .center-hero h2 {
                font-size: 22px;
              }

              .instagram-ai-image-automation-list .center-hero p {
                font-size: 13px;
                padding: 0 16px;
                word-break: keep-all;
                margin: 0;
              }

              .instagram-ai-image-automation-list .hero-button-wrap {
                width: 100%;
              }

              .instagram-ai-image-automation-list .hero-button-wrap .common_button {
                width: 100% !important;
              }

              .instagram-ai-image-automation-list .workflow-container {
                flex-direction: column;
                align-items: stretch;
                gap: 8px;
                padding: 24px 16px;
              }

              .instagram-ai-image-automation-list .workflow-divider {
                width: 100%;
                padding: 8px 0;
                transform: rotate(90deg);
                height: 30px;
              }

              .instagram-ai-image-automation-list .workflow-step {
                padding: 0;
              }

              .instagram-ai-image-automation-list .workflow-icon {
                width: 40px;
                height: 40px;
                font-size: 16px;
                margin-bottom: 12px;
              }

              .instagram-ai-image-automation-list .workflow-step h4 {
                font-size: 14px;
              }

              .instagram-ai-image-automation-list .filter-controls-row {
                flex-direction: column;
                align-items: stretch;
              }

              .instagram-ai-image-automation-list .filter-select-wrap,
              .instagram-ai-image-automation-list .date-range-group {
                width: 100%;
                min-width: 0;
              }

              .instagram-ai-image-automation-list .date-range-group {
                justify-content: space-between;
              }

              .instagram-ai-image-automation-list .date-input {
                flex: 1;
                width: auto;
              }

              .instagram-ai-image-automation-list .btn-apply {
                width: 100%;
              }

              .instagram-ai-image-automation-list .filter-chips-row {
                flex-direction: column;
                align-items: flex-start;
                gap: 16px;
              }

              .instagram-ai-image-automation-list .total-count {
                align-self: flex-end;
              }

              .instagram-ai-image-automation-list .table-responsive {
                overflow-x: visible;
              }

              .instagram-ai-image-automation-list .robo-table,
              .instagram-ai-image-automation-list .robo-table tbody {
                display: block;
                width: 100%;
                min-width: 100%;
              }

              .instagram-ai-image-automation-list .robo-table thead {
                display: none;
              }

              .instagram-ai-image-automation-list .robo-table tr {
                display: flex;
                flex-direction: column;
                background: var(--bg-canvas);
                border: 1px solid var(--border-color);
                border-radius: 12px;
                padding: 20px;
                margin-bottom: 16px;
                box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03);
                gap: 12px;
              }

              .instagram-ai-image-automation-list .robo-table tr:hover {
                background: var(--bg-canvas);
              }

              .instagram-ai-image-automation-list .robo-table td {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0;
                border: none;
                font-size: 13px;
                text-align: right;
                width: 100%;
              }

              .instagram-ai-image-automation-list .robo-table td::before {
                content: attr(data-label);
                font-weight: 600;
                color: var(--text-muted);
                width: 110px;
                flex-shrink: 0;
                text-align: left;
                font-size: 12px;
              }

              .instagram-ai-image-automation-list .robo-table td:nth-child(1) {
                display: none;
              }

              .instagram-ai-image-automation-list .robo-table td:nth-child(2) {
                display: block;
                text-align: left;
                border-bottom: 1px solid var(--border-light);
                padding-bottom: 12px;
                margin-bottom: 4px;
              }

              .instagram-ai-image-automation-list .robo-table td:nth-child(2)::before {
                display: none;
              }

              .instagram-ai-image-automation-list .robo-table td:nth-child(3) {
                align-items: flex-start;
                text-align: left;
              }

              .instagram-ai-image-automation-list .robo-table td:nth-child(3) .cell-link {
                text-align: right;
                word-break: break-all;
                white-space: normal;
                padding-left: 10px;
              }

              .instagram-ai-image-automation-list .cell-account {
                text-align: right;
              }

              .instagram-ai-image-automation-list .cell-account span {
                display: inline;
                margin-left: 4px;
              }

              .instagram-ai-image-automation-list .pagination-container {
                flex-direction: row;
                justify-content: center;
                gap: 16px;
                padding: 16px 0;
              }

              .instagram-ai-image-automation-list .page-numbers {
                margin: 0;
              }

              // .instagram-ai-image-automation-list .page-size-selector {
              //   display: none;
              // }

              .non_connection_hide {
                  margin: 0px 0px 0px auto !important;
              }
            }
          `}
        </style>

        <div
          id="page-wrapper"
          className="instagram-ai-image-automation-list"
          data-instagram-tutorial-ready={tutorialListLoaded ? "true" : "false"}
        >
          <main className="main-content">
            {/* <header className="top-header">
              <span>설정 &gt;</span> AI 자동 환경설정
            </header> */}

            <div className="content-inner">
              <section className="center-hero">
                <h2>AI 콘텐츠 자동 발행 설정</h2>
                <p>
                  SNS의 콘텐츠를 원하는 주기마다 자동 제작하고 자동 발행하도록 설정하고 관리하세요.
                </p>
                <div className="hero-button-wrap">
                  <Button
                    type={"hover_mint"}
                    width={"160px"}
                    height={"44px"}
                    fontSize={"15px"}
                    onClick={() => { window.location.href = "/shop/instagram/InstagramCreateAiImageAutomation"; }}
                  >
                    <img src="https://robomd.io/static/media/default_plus.466aee97.svg" style={{width:"14px", filter:"brightness(0)"}} alt="+"/>
                    <span>
                      새 자동화 등록
                    </span>
                  </Button>
                </div>
              </section>

              {/* <section className="workflow-container">
                <div className="workflow-step">
                  <div className="workflow-icon"><i className="fa fa-solid fa-images"></i></div>
                  <h4><span className="step-num">1</span> AI 맞춤 이미지 생성</h4>
                  <p>사전 등록된 스튜디오 프롬프트와 상품 정보를 바탕으로 시각적으로 돋보이는 이미지를 지속해서 생성해 냅니다.</p>
                </div>

                <div className="workflow-divider"><i className="fa fa-solid fa-chevron-right"></i></div>

                <div className="workflow-step">
                  <div className="workflow-icon"><i className="fa fa-solid fa-pen-nib"></i></div>
                  <h4><span className="step-num">2</span> 맞춤 카피 & 해시태그</h4>
                  <p>AI 카피라이터가 학습한 브랜드 보이스를 적용하여 반응을 이끌어내는 문구와 최적의 해시태그를 덧붙입니다.</p>
                </div>

                <div className="workflow-divider"><i className="fa fa-solid fa-chevron-right"></i></div>

                <div className="workflow-step">
                  <div className="workflow-icon"><i className="fa fa-solid fa-calendar-check"></i></div>
                  <h4><span className="step-num">3</span> 정기 스케줄링 자동 실행</h4>
                  <p>지정해둔 자동 실행 주기와 등록방식에 따라 콘텐츠를 자동 업로드하거나 콘텐츠 목록에 저장하며, 필요하면 자동 제작을 중지할 수 있습니다.</p>
                </div>
              </section> */}

              <section className="list-section-wrapper">
                <div className="filter-header">
                  <div className="filter-controls-row">
                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="statusSelect"
                        className="form-control"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="40px"
                        padding="10px 32px 10px 14px"
                        list={STATUS_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={status}
                        placeHolder="전체 상태"
                        onClickOption={this.handleSelectBox("status")}
                        tabIndex={0}
                      />
                    </div>
                    <div className="filter-select-wrap">
                      <SelectBoxV2
                        id="typeSelect"
                        className="form-control"
                        pageWrapperName="common-page-wrapper"
                        width="100%"
                        height="40px"
                        padding="10px 32px 10px 14px"
                        list={TYPE_OPTIONS}
                        optionTexttName="text"
                        optionValuetName="value"
                        selectedValue={type}
                        placeHolder="전체 유형"
                        onClickOption={this.handleSelectBox("type")}
                        tabIndex={0}
                      />
                    </div>

                    <div className="date-range-group">
                      <div>
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => this.setState({ startDate: date, page: 1 })}
                          selectsStart
                          startDate={startDate}
                          endDate={endDate}
                          maxDate={endDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="시작일"
                          customInput={<input className="date-input" />}
                        />
                      </div>
                      <span style={{ color: "var(--text-muted)" }}>~</span>
                      <div>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => this.setState({ endDate: date, page: 1 })}
                          selectsEnd
                          startDate={startDate}
                          endDate={endDate}
                          minDate={startDate || undefined}
                          dateFormat="yyyy.MM.dd"
                          locale={ko}
                          isClearable
                          placeholderText="종료일"
                          customInput={<input className="date-input" />}
                        />
                      </div>
                    </div>

                    <button
                      className="btn-apply"
                      type="button"
                      onClick={() => this.setState({ page: 1 }, this.fetchPostsFromApi)}
                    >
                      필터 적용
                    </button>
                  </div>

                  <div className="filter-chips-row">
                    <div className="chip-group">
                      <button type="button" className={"chip-btn" + (!dateType || dateType === "all" ? " active" : "")} onClick={() => this.setQuickRange("all")}>전체</button>
                      <button type="button" className={"chip-btn" + (dateType === "today" ? " active" : "")} onClick={() => this.setQuickRange("today")}>오늘</button>
                      <button type="button" className={"chip-btn" + (dateType === "week" ? " active" : "")} onClick={() => this.setQuickRange("week")}>이번 주</button>
                      <button type="button" className={"chip-btn" + (dateType === "month" ? " active" : "")} onClick={() => this.setQuickRange("month")}>이번 달</button>
                    </div>
                    <div className="total-count">총 <span>{this.fmtNumber(total)}</span>개</div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table className="robo-table">
                    <thead>
                      <tr>
                        <th style={{ width: "4%" }}>No.</th>
                        {this.renderSortHead("설정명", "ias.setting_name", "left", "13%")}
                        <th style={{ width: "11%" }}>계정</th>
                        <th style={{ width: "8%" }}>피드 이미지 구성</th>
                        <th style={{ width: "7%" }}>이미지 비율</th>
                        <th style={{ width: "17%" }}>AI 스튜디오</th>
                        <th style={{ width: "7%" }}>등록방식</th>
                        <th style={{ width: "9%" }}>문구 설정</th>
                        <th style={{ width: "7%" }}>동작여부</th>
                        <th style={{ width: "9%" }}>자동 실행 주기</th>
                        {this.renderSortHead("등록일", "ias.reg_date", "center", "8%")}
                        <th
                          style={{ width: "7%" }}
                          {...(tutorialListLoaded && rows.length === 0
                            ? { "data-instagram-tutorial": "ai-auto-manage-empty" }
                            : {})}
                        >
                          관리
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.length === 0 ? (
                        <tr>
                          <td colSpan={12} className="empty-cell">
                            조건에 맞는 자동설정이 없습니다.
                          </td>
                        </tr>
                      ) : (
                        rows.map((row, index) => {
                          const seq = row.id;
                          const stateKey = "is_enabled_" + seq;
                          const curr = this.state[stateKey] == null ? row.is_enabled : this.state[stateKey];

                          return (
                            <tr
                              key={row.id}
                              onClick={() => {
                                window.location.href = `/shop/instagram/InstagramCreateAiImageAutomation?instagram_ai_image_auto_setting_seq=${row.id}`;
                              }}
                            >
                              <td data-label="No.">{(page - 1) * pageSize + index + 1}</td>
                              <td data-label="설정명" className="text-left cell-title">
                                {row.setting_name || "-"}
                                {/* <span>{row.type === "SLIDE" ? "슬라이드 자동화" : "싱글 자동화"}</span> */}
                              </td>
                              <td data-label="계정" className="cell-account">
                                <div className="channel-account-list">
                                  {row.instagram_publish_yn === "Y" && (
                                    <div className="channel-account-row">
                                      <span className="channel-account-label">Instagram</span>
                                      <span className="channel-account-value">{row.username ? `@${row.username}` : (row.facebook_username || "-")}</span>
                                    </div>
                                  )}
                                  {row.threads_publish_yn === "Y" && (
                                    <div className="channel-account-row">
                                      <span className="channel-account-label">Threads</span>
                                      <span className="channel-account-value">{this.getThreadsAccountLabel(row.threads_access_token_seq)}</span>
                                    </div>
                                  )}
                                  {row.instagram_publish_yn !== "Y" && row.threads_publish_yn !== "Y" ? "-" : null}
                                </div>
                              </td>
                              <td data-label="피드 이미지 구성">
                                <span className="badge badge-neutral">
                                  {row.type === "SLIDE"
                                    ? `슬라이드 피드${row.slide_count ? ` (${row.slide_count}장)` : ""}`
                                    : "싱글 피드"}
                                </span>
                              </td>
                              <td data-label="이미지 비율">
                                <span
                                  className={
                                    "badge " +
                                    ((!row.image_ratio || row.image_ratio === "1:1")
                                      ? "badge-auto"
                                      : row.image_ratio === "4:5"
                                      ? "badge-manual"
                                      : row.image_ratio === "16:9"
                                      ? "badge-published"
                                      : "badge-failed")
                                  }
                                >
                                  {row.image_ratio || "1:1"}
                                </span>
                              </td>
                              <td data-label="AI 스튜디오">
                                <span className="cell-link" style={{ color: "var(--text-secondary)" }}>{row.history_title || "-"}</span>
                              </td>
                              <td data-label="등록방식">
                                {curr !== "Y" ? (
                                  <span className="badge badge-neutral">중지</span>
                                ) : row.publish_type === "PUBLISH" ? (
                                  <span className="badge badge-published">자동업로드</span>
                                ) : row.publish_type === "DRAFT" ? (
                                  <span className="badge badge-manual">목록저장</span>
                                ) : (
                                  <span className="badge badge-failed">-</span>
                                )}
                              </td>
                              <td data-label="문구 설정">
                                {/* 기존 문장 작성 방식과 무관하게 AI 카피라이터 전용으로 표시 */}
                                <div className="copywriter-setting-wrap">
                                  <span className="badge badge-neutral">AI 카피라이터</span>
                                  <span
                                    className="copywriter-preset-title"
                                    title={row.text_mode === "AI" && row.copywriter_preset_title ? row.copywriter_preset_title : "베이직 AI"}
                                  >
                                    {row.text_mode === "AI" && row.copywriter_preset_title ? row.copywriter_preset_title : "베이직 AI"}
                                  </span>
                                </div>
                              </td>
                              <td data-label="동작여부">
                                {curr === "Y" ? (
                                  <div
                                    className="non_connection_hide automation-status-toggle"
                                    title="클릭하여 자동 제작 중지"
                                    onClick={(e) => this.onClickToggleEnabled(e, seq, stateKey, "N")}
                                  >
                                    <div className="card-text btn_robomd_recomendation_back automation-status-track">
                                      <span className="automation-status-back-label right">중지</span>
                                      <span className="card-text btn_robomd_recomendation_on_front automation-status-front running">자동 제작 중</span>
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className="non_connection_hide automation-status-toggle"
                                    title="클릭하여 자동 제작 시작"
                                    onClick={(e) => this.onClickToggleEnabled(e, seq, stateKey, "Y")}
                                  >
                                    <div className="card-text btn_robomd_recomendation_back automation-status-track">
                                      <span className="automation-status-back-label left">시작</span>
                                      <span className="card-text btn_robomd_recomendation_off_front automation-status-front stopped">자동 제작 중지</span>
                                    </div>
                                  </div>
                                )}
                              </td>
                              <td data-label="자동 실행 주기" className="schedule-cell">
                                {this.renderScheduleCell(row)}
                              </td>
                              <td data-label="등록일" className="cell-date">
                                {row.reg_date_format || "-"}
                              </td>
                              <td data-label="관리" onClick={(e) => e.stopPropagation()}>
                                <div className="automation-action-group">
                                  <button
                                    type="button"
                                    className="automation-duplicate-btn"
                                    data-instagram-tutorial={index === 0 ? "ai-auto-duplicate" : undefined}
                                    disabled={this.state.duplicatingSettingSeq === row.id || this.state.deletingSettingSeq === row.id}
                                    onClick={(e) => this.duplicateAutomationSetting(e, row)}
                                  >
                                    <i className="fa fa-solid fa-copy" aria-hidden="true" />
                                    복제
                                  </button>
                                  <button
                                    type="button"
                                    className="automation-delete-btn"
                                    data-instagram-tutorial={index === 0 ? "ai-auto-delete" : undefined}
                                    disabled={this.state.deletingSettingSeq === row.id || this.state.duplicatingSettingSeq === row.id}
                                    onClick={(e) => this.openDeleteConfirmDialog(e, row)}
                                  >
                                    <i className="fa fa-solid fa-trash" aria-hidden="true" />
                                    삭제
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="pagination-container">
                  <div></div>

                  <div className="page-numbers">
                    <button type="button" disabled={page <= 1} onClick={() => this.goPage(page - 1)}>
                      <i className="fa fa-solid fa-caret-left"></i>
                    </button>
                    {renderPageButtons()}
                    <button type="button" disabled={page >= totalPages} onClick={() => this.goPage(page + 1)}>
                      <i className="fa fa-solid fa-caret-right"></i>
                    </button>
                  </div>

                  <div className="page-size-selector">
                    <span>페이지당</span>
                    <SelectBoxV2
                      id="pageSizeSelect"
                      className="form-control"
                      pageWrapperName="common-page-wrapper"
                      width="120px"
                      height="36px"
                      padding="6px 30px 6px 10px"
                      list={this.props.pageSizes}
                      optionTexttName="text"
                      optionValuetName="value"
                      selectedValue={this.state.pageSize}
                      placeHolder="페이지 크기"
                      onClickOption={(text, value) => this.changePageSize({ target: { value } })}
                      tabIndex={0}
                    />
                  </div>
                </div>
              </section>
            </div>
          </main>
        </div>

        {this.state.title_content_dialog_show_state && (
          <TitleContentDialogV2
            title={this.state.title_content_dialog_title}
            content={this.state.title_content_dialog_content}
            button_list={this.state.title_content_dialog_button_list}
            popup_close={this.closeDeleteConfirmDialog}
          />
        )}

        {this.state.warning_dialog_show_state && (
          <WarningDialog
            content={this.state.warning_dialog_content}
            button_list={this.state.warning_dialog_button_list}
            popup_close={this.closeWarningDialog}
          />
        )}

        {this.state.save_dialog_show_state && (
          <SaveDialogV2
            content={this.state.save_dialog_content}
            button_list={this.state.save_dialog_button_list}
          />
        )}
      </>
    );
  }
}